<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter">LIST OF MAPS</h1>
<p class="hanging1"><a href="#/OEBPS/map.htm#map1">1. The conquests of Islam by 750, and towns with large Jewish communities</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map2">2. Jewish communities in the Arabian Peninsula at the time of Mohammed</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map3">3. Jewish traders in the Eighth and Ninth Centuries</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map4">4. Jewish communities in Spain during Muslim rule, 711–1236</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map5">5. Jews seeking refuge in Muslim lands from Christian persecution, 1012–1540</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map6">6. The Ottoman Empire in 1850</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map7">7. Jewish communities in Ottoman Palestine by 1914</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map8">8. Birthplaces of Jews born in Muslim lands, deported to their deaths from France, 1942–1944</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map9">9. Former Jewish communities in Morocco</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map10">10. Former Jewish communities in Algeria and the area around Algiers</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map11">11. Former Jewish communities in Tunisia</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map12">12. Former Jewish communities in Libya</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map13">13. Former Jewish communities in Egypt</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map14">14. Former Jewish communities in Lebanon</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map15">15. Former Jewish communities in Syria</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map16">16. Former Jewish communities in Iraq</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map17">17. Former Jewish communities in Iran</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map18">18. Former Jewish communities in Afghanistan and the Khanate of Bukhara</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map19">19. Former Jewish communities in Yemen</a></p>
<p class="hanging1"><a href="#/OEBPS/map.htm#map20">20. The ‘Second Exodus,’ 1947–1957</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// listofmap.vue?12fb585e